import Backdrop from "@mui/material/Backdrop";
import Fade from "@mui/material/Fade";
import Modal from "@mui/material/Modal";
import React from "react";
import { Card, Image } from "react-bootstrap";
import "../../Assets/Styles/pages/uploadImage.scss";
import CancelButton from "../Cancel_button/Cancel_button";
import { Avatar } from "@mui/material";

const ReviewModal = ({ review, setReview, setOpen, open }) => {
  const generateInitials = (name) => {
    if (open) {
      const names = name.split(" ");
      let initials = "";
      if (names.length > 0) {
        initials += names[0].charAt(0);
        if (names.length > 1) {
          initials += names[names.length - 1].charAt(0);
        }
        // else
        //     initials += names[0].charAt(names[0].length - 1)
      }
      return initials.toUpperCase();
    }
  };

  const generateRandomColor = () => {
    if (open) {
      const colors = ["#964B00", "#39918C", "#D0B49F", "#AB6B51", "#2F435A"]; // Add more primary colors if needed
      const randomIndex = Math.floor(Math.random() * colors.length);
      return colors[randomIndex];
    }
  };

  return (
    <Modal
      open={open}
      onClose={() => {
        setOpen(false);
        setReview(null);
      }}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 800,
      }}
    >
      <Fade in={open}>
        {open && (
          <Card className=" reviewCard model min_w_xs_0 w-xs-90 m-0">
            <Card.Body>
              <CancelButton
                close={() => {
                  setOpen(false);
                  setReview(null);
                }}
              />
              <div className="text-center productSansBold text_16 border-bottom mx-5">
                <Avatar
                  className="p-0 size_44x44 text_19 mx-auto d-flex align-items-center my-1 mb-3"
                  style={{
                    background: generateRandomColor(), // Replace "your-color" with the desired background color
                  }}
                  alt={review.name}
                  src={review.img}
                >
                  {review.img ? (
                    <Image src={review.img} alt={review.name} />
                  ) : (
                    generateInitials(review.name)
                  )}
                </Avatar>
                <h5>{review.name}</h5>
              </div>
              <Card.Text className="m-4 my-1 text_16 text-center fullReviewScroll productSansLight">
                {review.description}
              </Card.Text>
            </Card.Body>
          </Card>
        )}
      </Fade>
    </Modal>
  );
};

export default ReviewModal;
